module.exports = __webpack_public_path__ + "img/seller_draft postings.8d31c633.svg";